import { Injectable } from "@angular/core";
import { FeaturePermissionName } from "@common/ADAPT.Common.Model/embed/feature-permission-name.enum";
import { AuthorisationService } from "../authorisation/authorisation.service";

@Injectable({
    providedIn: "root",
})
export class LinkAuthService {
    public static readonly ViewLink = "viewLink";
    public static readonly EditLink = "editLink";

    public static registerAccess(authorisationService: AuthorisationService) {
        const editPermissions = [
            FeaturePermissionName.StewardshipWorkMeetingsEdit,
            FeaturePermissionName.StewardshipWorkMeetingsParticipantEdit,
            FeaturePermissionName.StewardshipObjectivesEdit,
            FeaturePermissionName.StewardshipWorkKanbanPersonalEdit,
            FeaturePermissionName.StewardshipWorkKanbanPublicEdit,
            FeaturePermissionName.StewardshipWorkKanbanEdit,
        ];

        authorisationService.registerAccessVerifier(
            LinkAuthService.ViewLink,
            {
                requirePermissions: [
                    FeaturePermissionName.StewardshipWorkMeetingsRead,
                    FeaturePermissionName.StewardshipObjectivesRead,
                    FeaturePermissionName.StewardshipWorkKanbanPublicRead,
                    FeaturePermissionName.StewardshipWorkKanbanRead,
                    ...editPermissions,
                ],
            },
        );

        authorisationService.registerAccessVerifier(
            LinkAuthService.EditLink,
            {
                requirePermissions: editPermissions,
            },
        );
    }
}
